// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import { CREATE_APPOINTMENT, DETAIL_APPOINTMENT, UPDATE_APPOINTMENT } from '~/utils/constants/actionType';
import appointmentApi from '~/apis/appoinment';
import { IFormAppointment, IPayloadEditAppointment } from '~/utils/interface/appointment';

export const createAppointment = createAsyncThunk(
  CREATE_APPOINTMENT,
  async (body: IFormAppointment, { rejectWithValue }) => {
    try {
      const resp = await appointmentApi.createAppointment(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const detailAppointment = createAsyncThunk(
  DETAIL_APPOINTMENT,
  async (appointmentId: string, { rejectWithValue }) => {
    try {
      const resp = await appointmentApi.detailAppointment(appointmentId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateAppointment = createAsyncThunk(
  UPDATE_APPOINTMENT,
  async (body: IPayloadEditAppointment, { rejectWithValue }) => {
    try {
      const resp = await appointmentApi.updateAppointment(body);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
